export type Decimal = string

export function toNumber(value: Decimal | null | undefined): number {
  if (value === null || value === undefined || value === '') return 0
  const parsed = Number(value)
  return Number.isFinite(parsed) ? parsed : 0
}

export function toDecimal(value: number): Decimal {
  return value.toFixed(2)
}

export function addDecimals(values: Array<Decimal | null | undefined>): Decimal {
  const sum = values.reduce<number>((acc, value) => acc + toNumber(value), 0)
  return toDecimal(sum)
}

/**
 * Leest een door de gebruiker getypt bedrag: accepteert zowel "1250.00" als de
 * Nederlandse notatie "1.250,00", met of zonder euroteken en spaties. Geeft null
 * terug bij onleesbare invoer, zodat de aanroeper een fout kan tonen in plaats
 * van stil 0 weg te schrijven.
 */
export function parseAmountInput(value: string): number | null {
  const cleaned = value.replace(/[\s €]/g, '')
  if (cleaned === '') return null

  const lastComma = cleaned.lastIndexOf(',')
  const lastDot = cleaned.lastIndexOf('.')
  const decimalSeparator = lastComma > lastDot ? ',' : lastDot > lastComma ? '.' : ''

  let normalized = cleaned
  if (decimalSeparator === ',') {
    normalized = cleaned.replace(/\./g, '').replace(',', '.')
  } else if (decimalSeparator === '.') {
    normalized = cleaned.replace(/,/g, '')
  } else {
    normalized = cleaned.replace(/[.,]/g, '')
  }

  if (!/^-?\d*\.?\d*$/.test(normalized) || normalized === '' || normalized === '-') return null

  const parsed = Number(normalized)
  return Number.isFinite(parsed) ? parsed : null
}
